<template>
  <v-app>
    <link rel="stylesheet" href="//use.typekit.net/kje0rtg.css" media="all" />
    <v-container grid-list-md text-xs-center fluid pl-0 pr-0>
      <CompletedMessage v-if="completed" />
      <Calculator v-if="!completed" />
    </v-container>
  </v-app>
</template>

<script>
import Calculator from './components/Calculator.vue'
import CompletedMessage from './components/CompletedMessage.vue'

export default {
  name: 'App',
  components: {
    Calculator,
    CompletedMessage,
  },
  created() {
    if (window?.location?.search?.includes('completed')) {
      this.completed = true
    }
    this.$vuetify.theme.themes.light.primary = this.$primaryColorFromDrupal
  },
  mounted () {
    // Embedded into Drupal's markup.
    if (window.drupalSettings && window.drupalSettings) {
      const currentLanguage = window.drupalSettings.path.currentLanguage
      this.$setLanguage(currentLanguage ? currentLanguage : 'en')
    }
    // Iframed into a Drupal site.
    if (window.parent && window.parent.drupalSettings) {
      const currentLanguage = window.parent.drupalSettings.path.currentLanguage
      this.$setLanguage(currentLanguage ? currentLanguage : 'en')
    }
  },
  data: () => ({
    completed: false,
  }),
}
</script>

<style>
html {
  overflow-y: hidden;
}

#app {
  background-color: #fff;
  color: #2c3e50;
  font-family: omnes-pro, sans-serif, Helvetica, Arial, sans-serif;
  font-size: 16px;
}

.v-application--wrap {
  min-height: 0;
}
</style>
